import "jspdf-autotable";
import { useEffect, useState } from "react";
import invoiceService from "../services/invoice.service";
import "./../css/styles.css";
import Swal from "sweetalert2";
import { errorToast, successToast } from "../../../react-toastfiy/toast";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";





export default function useInvoiceList(active = {}) {
  const endDay = new Date();

  const month = endDay.getMonth();
  const year = endDay.getFullYear();
  const lastDateOfMonth = new Date(year, month + 1, 0).getDate();

  const end_date = `${year}-${String(month + 1).padStart(2, "0")}-${lastDateOfMonth}`
  const start_date = `${year}-${String(month + 1).padStart(2, "0")}-01`

  const [data, setData] = useState([])
  const [filterData, setFilterData] = useState([])
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date)
  const [fetchData, setFetchData] = useState(true);





  console.log({ startDate, endDate });

  useEffect(() => {
    document.title = "Invoice";
    try {

      setLoading(true)
      const formData = new FormData();
       if (startDate) {
        formData.append("start_date", startDate);
      }
      if (endDate) {
        formData.append("end_date", endDate);
      }

      invoiceService.getCreatedInvoiceList(formData).then((res) => {
        console.log({ res });
        setLoading(false)
        setFetchData(true)
        if (res?.status === 200) {
          console.log(res);
          setData(res?.data);
          setFilterData(res?.data);
        } else {
          setData([]);
          setFilterData([]);
          setFetchData(true)
        }
      })

    } catch (error) {
      setLoading(false)
      setFetchData(true)
      errorToast("An error occurred while fetching the invoice list.", error);
    }
  }, []);





  const handleGetData = async (startDate, endDate) => {
    try {
      setLoading(true)
      const formData = new FormData();

      // Only append dates if they are provided
      if (startDate) {
        formData.append("start_date", startDate);
      }
      if (endDate) {
        formData.append("end_date", endDate);
      }

      const res = await invoiceService.getCreatedInvoiceList(formData)
      setLoading(false)
      if (res?.status === 200) {
        console.log(res);
        setData(res?.data);
        setFilterData(res?.data);
      } else {
        setData([]);
        setFilterData([]);
        setFetchData(true)
      }

    } catch (error) {
      setLoading(false)
      setFetchData(true)
      errorToast("An error occurred while fetching the invoice list.", error);
    }
  }


  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this invoice?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        focusCancel: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const formData = new FormData();

          formData.append("invoice_id", id);

          try {
            const response = await invoiceService.DeleteInvoice(formData);
            if (response?.status === 200) {
              successToast(response?.msg);
              // Instead of reloading the page, we should update the data
              // Remove the deleted item from the data and filterData arrays
              setData(prevData => prevData.filter(item => item.invoice_id !== id));
              setFilterData(prevFilterData => prevFilterData.filter(item => item.invoice_id !== id));
              return true;
            }
          } catch (err) {
            Swal.showValidationMessage(err.message);
            throw err;
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    } catch (error) {
      console.error("Error deleting invoice:", error);
      errorToast("An error occurred while deleting the invoice.");
    }
  };

  const filtersList = [
    { key: "state", name: "State", id: "state" },
  ];

  const resetDateFilters = () => {
    setStartDate("");
    setEndDate("");
    setFilterData(data);
  };

  const exportToExcel = (data) => {
    // Prepare data for Excel (convert to array of objects with proper headers)
    const excelData = data.map((item, index) => ({
      "#": index + 1,
      "Name": item?.name || "",
      "Phone": item?.phone || "",
      "State": item?.state || "",
      "Invoice Number": item?.invoice_number || "",
      "Invoice Date": item?.invoice_date || "",
      "Total Amount": item?.total_amount || "",
      "Taxable Amount": item?.taxable_amount?.toFixed(2) || "",
      "Description": item?.line_items && item?.line_items.length > 0 ? item?.line_items[0].description : "",
      "Invoice URL": item?.invoice_url || "",

    }));

    // Create a new workbook and worksheet
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Invoices");

    // Generate buffer and save file
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, "invoices.xlsx");
  }

  return {
    data, filterData, setFilterData, handleDelete, loading, startDate, setStartDate, endDate, setEndDate, handleGetData, filtersList, fetchData, resetDateFilters, exportToExcel
  };
}